import { ColumnConfiguration, GridData } from 'api';
import { v4 as uuidv4 } from 'uuid';

export type Ipa = {
  id: string;
  isNew: boolean;
  ooIPAKey: number;
  ipaName: string;
  createdDate: Date;
  createdBy: string;
  updatedDate: Date;
  updatedBy: string;
};

//TODO: Return columns from API endpoint
const ipaColumns: ColumnConfiguration[] = [
  {
    name: 'ipaName',
    displayName: 'IPA Name',
    type: 'string',
    required: true,
    defaultValue: '',
    editable: true,
    flex: 1,
  },
  {
    name: 'updatedBy',
    displayName: 'Last Updated By',
    type: 'string',
    required: true,
    defaultValue: '',
    editable: false,
    flex: 1,
  },
  {
    name: 'updatedDate',
    displayName: 'Last Updated Date',
    type: 'date',
    required: true,
    defaultValue: new Date().toUTCString(),
    editable: false,
    flex: 1,
  },
  {
    name: 'actions',
    type: 'actions',
    displayName: 'Actions',
    width: 100,
    cellClassName: 'actions',
    required: true,
    editable: false,
    defaultValue: '',
  },
];

export const convertIpaToDataGrid = (ipas: Ipa[]): GridData => {
  const rows = ipas.map(ipa => ({
    ...ipa,
    id: uuidv4(),
    isNew: false,
  }));

  return {
    columns: ipaColumns,
    rows: rows,
  };
};

export const convertIpaResponse = (ipas: Ipa[]): Ipa[] => {
  const rows = ipas.map(ipa => ({
    ...ipa,
    id: uuidv4(),
    isNew: false,
  }));

  return rows;
};
